import { Box } from '@mui/system';

export default function Spacer() {
    return <Box display="flex" flex={1} />;
}
